export const DROPZONE_MESSAGE = {
  DEFAULT: 'Drop a file here or click to upload.',
  DEFAULT_ADD_FILES:
    'Drop more files or click to upload. You can upload up to 25 files.',
  INVALID_FILE_TYPE:
    'You have uploaded an invalid file type. Check the tooltip icon above for file size and type requirements.',
  INVALID_FILE_SIZE:
    'Your file exceeds the maximum upload size. Check the tooltip icon above for file size and type requirements.',
  EXCEED_MAX_NUM_FILES:
    'You have exceeded the maximum allowed number of files (25).',
  DUPLICATE_FILE: 'The file already exists. Try to rename it and upload again.',
  MAX_NUM_FILES: 'You have uploaded the maximum allowed number of files (25).',
}
